import { RouteComponentProps } from '@reach/router'

export const Home: React.FC<RouteComponentProps> = () => null
